"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputSize = exports.inputNovoDark = exports.inputNovo = exports.input = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const input = {
    backgroundColor: color_const_1.default.white,
    backgroundColorDisabled: color_const_1.default.cloudyBlue100,
    backgroundColorFixed: 'transparent',
    backgroundColorReadOnly: color_const_1.default.white,
    backgroundColorSemanticBlock: color_const_1.default.cloudyBlue100,
    borderColor: color_const_1.default.cloudyBlue300,
    borderColorError: color_const_1.default.coral,
    borderColorFixed: 'transparent',
    borderColorFocused: color_const_1.default.dodgerBlue,
    borderColorReadOnly: color_const_1.default.cloudyBlue300,
    borderColorSemanticBlock: color_const_1.default.cloudyBlue,
    borderRadius: 0,
    borderRadiusReadOnly: 0,
    borderStyle: 'solid',
    borderStyleDefaultSemanticBlock: 'solid',
    borderTransitionTiming: timing_const_1.default.fast,
    borderWidth: size_const_1.default.borderSizeDefault,
    borderWidthReadOnly: size_const_1.default.borderSizeDefault,
    borderWidthSemanticBlock: size_const_1.default.borderSizeDefault,
    color: color_const_1.default.pickledBluewood800,
    colorDisabled: color_const_1.default.cloudyBlue,
    colorFixed: color_const_1.default.steel700,
    colorIcon: color_const_1.default.steel700,
    colorPlaceholder: color_const_1.default.cloudyBlue,
    colorReadOnly: color_const_1.default.pickledBluewood800,
    colorSemanticBlock: color_const_1.default.steel700,
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: font_const_1.default.weightDefault,
    height: size_const_1.default.formItemSizeLarge,
    heightLarge: '48px',
    heightSmall: size_const_1.default.formItemSizeSmall,
    horizontalSpacing: size_const_1.default.default,
    horizontalSpacingReadOnly: size_const_1.default.default,
    iconHorizontalSpacing: size_const_1.default.default,
    iconSize: 24,
    letterSpacing: 'normal',
    lineHeight: font_const_1.default.lineHeightSm,
    minWidth: '40px',
    prefixSuffixHorizontalSpacing: size_const_1.default.default,
    prefixSuffixInsideInput: false,
    verticalSpacing: size_const_1.default.small,
    width: '296px',
    widthSemanticBlock: '60px',
};
exports.input = input;
const inputNovo = {
    ...input,
    ...novo.body01,
    backgroundColor: novo.ui05,
    backgroundColorDisabled: novo.ui05,
    backgroundColorReadOnly: novo.ui06,
    backgroundColorSemanticBlock: novo.ui05,
    borderColor: novo.ui05,
    borderColorDisabled: novo.ui05,
    borderColorError: novo.action03,
    borderColorFixed: 'transparent',
    borderColorFocused: novo.focus01,
    borderColorReadOnly: 'transparent',
    borderColorSemanticBlock: novo.ui05,
    borderRadius: '6px',
    borderRadiusReadOnly: '0',
    borderStyle: 'solid',
    borderStyleDefaultSemanticBlock: 'solid',
    borderTransitionTiming: '150ms',
    borderWidth: '2px',
    borderWidthReadOnly: '2px',
    borderWidthSemanticBlock: '2px',
    color: novo.textColor01,
    colorDisabled: novo.disabled02,
    colorFixed: novo.textColor01,
    colorIcon: novo.textColor01,
    colorPlaceholder: novo.textColor02,
    colorReadOnly: novo.textColor01,
    colorSemanticBlock: novo.textColor01,
    fontStretch: 'normal',
    fontStyle: 'normal',
    height: '40px',
    heightLarge: '48px',
    heightSmall: '32px',
    horizontalSpacing: '14px',
    horizontalSpacingReadOnly: '0',
    iconHorizontalSpacing: '0',
    iconSize: 20,
    minWidth: '40px',
    prefixSuffixHorizontalSpacing: '10px',
    prefixSuffixInsideInput: true,
    verticalSpacing: '2px 0 0',
    width: '320px',
    widthSemanticBlock: '60px',
};
exports.inputNovo = inputNovo;
const inputNovoDark = {
    ...inputNovo,
    backgroundColor: novoDark.ui05,
    backgroundColorDisabled: novoDark.ui05,
    backgroundColorReadOnly: novoDark.ui06,
    backgroundColorSemanticBlock: novoDark.ui05,
    borderColor: novoDark.ui05,
    borderColorDisabled: novoDark.ui05,
    borderColorError: novoDark.action03,
    borderColorFocused: novoDark.focus01,
    borderColorSemanticBlock: novoDark.ui05,
    color: novoDark.textColor01,
    colorDisabled: novoDark.disabled02,
    colorFixed: novoDark.textColor01,
    colorIcon: novoDark.textColor01,
    colorPlaceholder: novoDark.textColor02,
    colorReadOnly: novoDark.textColor01,
    colorSemanticBlock: novoDark.textColor01,
};
exports.inputNovoDark = inputNovoDark;
const inputSize = {
    small: 'small',
    default: 'default',
    large: 'large',
};
exports.inputSize = inputSize;
